import styled from 'styled-components'

import Button from '../../../../../../shared/components/Button'

export const ContainerForm = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  button {
    margin-top: 20px;
  }
`
export const Container = styled.div`
  width: 100%;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`
export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -150px;
  }

  @media (max-height: 668px) {
    bottom: -120px;
  }
`

export const ContainerText = styled.div`
  width: 100%;
  max-width: 513px;

  display: flex;
  flex-direction: column;

  padding: 0 25px;
`
